<template>
  <div
    id="modal-generate-report"
    class="modal fade"
    data-backdrop="static"
    data-keyboard="false"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content " v-if="show">
        <div class="modal-body  text-light p-4">
          <div v-if="!isLoading">
            <h3 class="font-weight-bold">Are you sure?</h3>
            <p class="fw-bold">
              Are you sure you want to export this report? It may take a while
              to fetch the data.
            </p>
          </div>
          <div v-else class="text-center">
            <div class="mb-3">
              <h1 class="font-weight-bold mb-0">{{ currentProgress }}%</h1>
              downloading...
            </div>
            <div
              class="progress"
              role="progressbar"
              aria-label="Default striped example"
              aria-valuenow="10"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              <div
                class="progress-bar progress-bar-striped"
                :style="`width: ${currentProgress}%`"
              ></div>
            </div>
          </div>
        </div>
        <div class="modal-footer " v-if="!isLoading">
          <button
            type="button"
            class="btn text-light"
            data-bs-dismiss="modal"
            @click="closeModal()"
          >
            Close
          </button>
          <button type="button" class="btn btn-primary" @click="fetchingData()">
            Export
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import API from "@/api";
import moment from "moment";
// import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import Helper from "@/helper";

export default {
  props: ["show", "totalPage", "videoType", "totalEntries", "dateFilter"],
  data() {
    return {
      dataSource: [],
      isLoading: false,
      currentProgress: 0,
      helper: Helper,
    };
  },
  watch: {
    show: {
      handler() {
        if (this.show) {
          $("#modal-generate-report").modal("show");
        } else {
          $("#modal-generate-report").modal("hide");
        }
      },
      immediate: true,
    },
    dataSource: {
      handler() {
        if (!this.dataSource.length) return;
        const data = this.dataSource.map((video) => {
          let size = 0;
          const vSize = video.video && video.video.size ? video.video.size : 0;
          const pvSize =
            video.videoProcessed && video.videoProcessed.size
              ? video.videoProcessed.size
              : 0;

          const result = vSize + pvSize;

          size = this.helper.autoFormatSize(result);

          const dashcamTable = {
            ID: video._id,
            URL: video.video && video.video.url ? video.video.url : "",
            "Upload Date": moment(video.createdAt).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            "Video Date": moment(video.datetime).format("YYYY-MM-DD HH:mm:ss"),
            "Process URL": video.processedVideo ? video.processedVideo : "-",
            District:
              video.district && video.district.name ? video.district.name : "-",
            Road: video.road && video.road.name ? video.road.name : "-",
            "Starting Lat Long": `${
              video.district && video.district.lat ? video.district.lat : ""
            }, ${
              video.district && video.district.lng ? video.district.lng : ""
            }`,
            Status: video.isReviewed ? "Reviewed" : "Pending Review",
            "Size (MB)": size,
          };

          const droneTable = {
            ID: video._id,
            URL: video.video && video.video.url ? video.video.url : "",
            "Upload Date": moment(video.createdAt).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            "Video Date": moment(video.datetime).format("YYYY-MM-DD HH:mm:ss"),
            "Process Date":
              video.videoProcessed && video.videoProcessed.createdAt
                ? moment(video.videoProcessed.createdAt).format(
                    "YYYY-MM-DD HH:mm:ss"
                  )
                : "-",
            District:
              video.district && video.district.name ? video.district.name : "-",
            Road: video.road && video.road.name ? video.road.name : "-",

            "Starting Lat Long": `${
              video.district && video.district.lat ? video.district.lat : ""
            }, ${
              video.district && video.district.lng ? video.district.lng : ""
            }`,
            Status: video.isReviewed ? "Reviewed" : "Pending Review",
            "Size (MB)": size,
          };
          return this.videoType === "dashcamvideos" ? dashcamTable : droneTable;
        });

        let totalVideoSize = this.dataSource
          .map((video) => {
            let size = 0;
            const vSize =
              video.video && video.video.size ? video.video.size : 0;
            const pvSize =
              video.videoProcessed && video.videoProcessed.size
                ? video.videoProcessed.size
                : 0;

            const sizeFile = vSize + pvSize;
            size = sizeFile;

            return size;
          })
          .reduce((a, b) => a + b, 0);

        const sizeInGb = this.helper.autoFormatSize(totalVideoSize);

        if (this.totalEntries === data.length) {
          this.$emit("close");
          Swal.fire({
            title: "Success!",
            icon: "success",
          });

          this.exportExcel(data, sizeInGb, this.videoType);
          this.currentProgress = 0;
          this.dataSource = [];
        }
      },
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },

    async exportExcel(data, sizeInGb, videoType) {
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet(`Report ${videoType.toUpperCase()}`);

      const title = `${videoType.toUpperCase()}/${moment().format(
        "YYYY-MM-DD"
      )}/${`${sizeInGb}`}`;
      const columnCount = Object.keys(data[0]).length;

      sheet.mergeCells(1, 1, 1, columnCount);
      const titleCell = sheet.getCell("A1");
      titleCell.value = {
        richText: [
          {
            text: title,
            font: { size: 28, bold: true },
            bold: true,
            underline: true,
          },
        ],
      };

      titleCell.alignment = { horizontal: "center", vertical: "middle" };
      sheet.getRow(1).height = 30;

      sheet.addRow([]);

      const headers = Object.keys(data[0]);
      const headerRow = sheet.addRow(headers);
      headerRow.font = { bold: true };

      data.forEach((row) => {
        sheet.addRow(Object.values(row));
      });

      sheet.columns.forEach((column) => {
        let maxLength = 10;
        column.eachCell({ includeEmpty: true }, (cell) => {
          const value = cell.value ? cell.value.toString() : "";
          maxLength = Math.max(maxLength, value.length);
        });
        column.width = maxLength + 2;
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(
        blob,
        `Report ${videoType.toUpperCase()} ${moment().format(
          "YYYY-MM-DD"
        )} ${sizeInGb}.xlsx`
      );
    },

    async fetchingData() {
      if (!this.totalPage) return;
      this.isLoading = true;
      let videos = [];
      let start = 0;

      let totalArr = [];
      for (let i = 0; i < Math.ceil(this.totalEntries / 100); i++) {
        totalArr.push(i);
      }

      for (const page of totalArr) {
        const pagenumber = page + 1;

        let startDate = this.dateFilter.start;
        let endDate = this.dateFilter.end;

        const response = await API.get(
          `${this.videoType}?datetime_gte=${startDate}&datetime_lte=${endDate}&_start=${start}&_sort=datetime:DESC`
        );

        if (response.data.length) {
          videos = [...videos, ...response.data];
        } else {
          videos = response.data;
        }

        this.dataSource = videos;
        this.currentProgress = Math.round((pagenumber / this.totalPage) * 100);
        start += 100;
      }

      this.isLoading = false;
    },
  },
};
</script>